import Vue from 'vue'
import storeModule from './modules/store';
import global from './modules/global';
import system from './modules/system';
import event from './modules/event';

import VueMeta from 'vue-meta'
import store from '@/state/store'
import VueRouter from 'vue-router'
import middlewarePipeline from './middlewarePipeline'

Vue.use(VueRouter)
Vue.use(VueMeta, {
    // The component option name that vue-meta looks for meta info on.
    keyName: 'page',
})

const routes = [
    ...storeModule,
    ...global,
    ...system,
    ...event
];

const router = new VueRouter({
    routes: routes,
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: 'history',
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
})

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

        const context = {from, next, router, to, store};
        // Before each route evaluates...
        const nextMiddleware = middlewarePipeline(context, middleware, 1);
        return middleware[0]({...context, next: nextMiddleware});
    }

    return next();
});

export default router
